import React, { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Select,
  DatePicker,
  Space,
  Form,
  message,
  Checkbox,
  Dropdown,
} from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
// Redux
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getClientid,
  getUserInfo,
  getUserList,
} from "redux/selectors";

import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  differenceBetweenTwoTime,
  getKenyanDateTime,
  generateHourMinutesFromMinutes,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, orderBy, reduce, uniqBy } from "lodash";
import ViewMore from "organisms/ViewMore";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { SortAscendingOutlined } from "@ant-design/icons";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-cell:last-child {
    min-width: 200px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }

  .ant-form-item {
    display: inline-block;
  }

  .outer-form {
    margin-right: 0px;
  }

  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
    display: flex;
    align-items: center; /* ⭐ key */
  }

  /* Placeholder */
  .ant-select-selection-placeholder {
    color: #000 !important;
    font-weight: 400;
  }

  /* Arrow & clear icon */
  .ant-select-arrow,
  .ant-select-clear {
    top: 50% !important;
    transform: translateY(-50%);
  }

  /* Input / button alignment */
  .ant-input-affix-wrapper,
  .ant-input,
  .ant-btn {
    display: flex;
    align-items: center;
  }
`;
const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 768px) {
    margin-left: -40px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function LateCheckIn({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userInfo,
  userList,
}) {
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [lateCheckinList, setLateCheckinList] = useState([]);
  const [CSVcheckinList, setCSVcheckinList] = useState([]);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  const [stafflateCheckinList, setStafflateCheckinList] = useState([]);
  const [staffName, setStaffName] = useState("");
  const [filterList, setFilterList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const [activeSortColumn, setActiveSortColumn] = useState([]);
  const [uiTableData, setUITableData] = useState([]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setUITableData(extra.currentDataSource);
  };

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  const STAFF_LIST = React.useMemo(() => {
    const unique = new Map();
    userList.forEach((val) => {
      unique.set(val.userid, {
        value: val.userid,
        label: val.fullname,
      });
    });
    return Array.from(unique.values()).sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );
  }, [userList]);

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 170,
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      width: 160,
    },
    {
      title: "Check-in Date",
      dataIndex: "checkindate",
      key: "checkindate",
      width: 150,
      render: (checkindate) => {
        const dateFormat = moment(checkindate).format("DD MMM YYYY");
        return `${dateFormat}`;
      },
    },
    {
      title: "Check-in time",
      dataIndex: "checkintime",
      key: "checkintime",
      width: 150,
    },
    {
      title: "Check-in cutoff",
      dataIndex: "shiftcutofftime",
      key: "shiftcutofftime",
      width: 150,
    },

    {
      title: "Late time",
      dataIndex: "late",
      key: "late",
      width: 120,
      render: (_, record) => {
        const diff = differenceBetweenTwoTime(
          record.shiftstarttime,
          record.checkintime
        );
        return generateHourMinutesFromMinutes(diff);
      },
    },
    {
      title: "Reason",
      dataIndex: "punchinreason",
      key: "punchinreason",
      width: 200,
      render: (reason) => {
        return (
          <>
            <ViewMore value={reason} />
          </>
        );
      },
    },
  ];

  const columnsWithSorting = columns.map((col) => ({
    ...col,
    sorter: activeSortColumn.includes(col.dataIndex)
      ? (a, b) => {
          const aVal = a[col.dataIndex];
          const bVal = b[col.dataIndex];

          // Date sort
          if (moment(aVal, moment.ISO_8601, true).isValid()) {
            return moment(aVal).valueOf() - moment(bVal).valueOf();
          }

          // String sort
          if (typeof aVal === "string") {
            return aVal.localeCompare(bVal);
          }

          // Number sort
          return (aVal ?? 0) - (bVal ?? 0);
        }
      : false,
  }));

  // 👉 show only selected columns if any selected
  const finalColumns =
    activeSortColumn.length > 0
      ? columnsWithSorting.filter((col) =>
          activeSortColumn.includes(col.dataIndex)
        )
      : columnsWithSorting;

  const CSVHeaders =
    activeSortColumn.length > 0
      ? columns
          .filter((col) => activeSortColumn.includes(col.dataIndex))
          .map((col) => ({
            label: col.title,
            key: col.title,
          }))
      : [
          { label: "Name", key: "Name" },
          { label: "Department", key: "Department" },
          { label: "Check-in Date", key: "Check-in Date" },
          { label: "Check-in time", key: "Check-in time" },
          { label: "Check-in cutoff", key: "Check-in cutoff" },
          { label: "Late Time", key: "Late Time" },
          { label: "Reason", key: "Reason" },
        ];
  const SORT_OPTIONS = columns.map((col) => ({
    label: col.title,
    value: col.dataIndex,
  }));

  const sortMenu = (
    <div
      style={{
        padding: 12,
        width: 200,
        maxHeight: 300,
        overflowY: "scroll",
        background: "#fff",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
        fontWeight: 400,
      }}
    >
      <Checkbox.Group
        value={activeSortColumn}
        options={SORT_OPTIONS}
        onChange={(values) => setActiveSortColumn(values)}
        style={{ display: "flex", flexDirection: "column", gap: 8 }}
      />
    </div>
  );

  useEffect(() => {
    list();
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    ClientId,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("start_date"),
    form.getFieldValue("department"),
  ]);

  const getAttendanceReport = async () => {
    return new Promise(async (resolve, reject) => {
      setLateCheckinList([]);
      const { start_date, end_date, duration_type, month, department } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      if (ClientId) {
        const { code, lateCheckinList = [] } = await CALL_API(
          `late-checkin-report/${ClientId}`,
          "post",
          {
            department: [""],
            // userRoleId === 1 || userRoleId === 6
            //   ? [department]
            //   : selectedDepartmentId,
            start_date: getMySqlDate(
              duration_type === 2 ? startDateOfMonth : start_date
            ),
            end_date: getMySqlDate(
              duration_type === 2 ? lastDateOfMonth : end_date
            ),
            reportingmanager: userInfo?.userid,
          }
        );
        setDisplayTableLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLateCheckinList(
            orderBy(lateCheckinList, ["checkindate"], ["desc"])
          );
          setStafflateCheckinList(
            orderBy(lateCheckinList, ["checkindate"], ["desc"])
          );
        }
      }
    });
  };

  const restrictPastDate = (current, element) => {
    let customDate = moment().format("YYYY-MM-DD");
    if (element === "end_date") {
      return current < moment(form.getFieldValue("created_date"));
    }
    return current && current < moment(customDate, "YYYY-MM-DD");
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  function getMonthName(monthIndex) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[monthIndex];
  }

  const prepareCSV = async () => {
    const exportData = uiTableData.length ? uiTableData : lateCheckinList;
    if (lateCheckinList.length > 0) {
      setCSVcheckinList(
        reduce(
          exportData,
          function (result, record) {
            const diff = differenceBetweenTwoTime(
              record.shiftstarttime,
              record.checkintime
            );
            const dateObj = new Date(record.checkindate);
            const day = dateObj.getDate();
            const month = getMonthName(dateObj.getMonth());
            const year = dateObj.getFullYear().toString().substr(-2);
            const formattedDate = `${day} ${month} ${year}`;

            const row = {
              Name: record.fullname,
              Department: record.departmentName,
              "Check-in Date": formattedDate,
              "Check-in time": record.checkintime,
              "Check-in cutoff": record.shiftcutofftime,
              "Late Time": generateHourMinutesFromMinutes(diff),
              Reason: record.punchinreason ? record.punchinreason : "-",
            };

            // 👉 if column filter active, send only selected
            if (activeSortColumn.length > 0) {
              const filteredRow = {};
              columns.forEach((col) => {
                if (activeSortColumn.includes(col.dataIndex)) {
                  filteredRow[col.title] = row[col.title];
                }
              });
              result.push(filteredRow);
            } else {
              result.push(row);
            }

            return result;
          },
          []
        )
      );

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
  };

  const handleChange = (event) => {
    setStaffName(event);
    if (event == "*") {
      getAttendanceReport();
    }
    const filteredStaffList = stafflateCheckinList.filter(
      (val) => val.userid === event
    );
    setLateCheckinList(filteredStaffList);
    setStafflateCheckinList(stafflateCheckinList);
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const calculateScrollY = () => {
      // const screenHeight = window.innerHeight;
      // const offset = 180; // Adjust this value as needed for headers/footers
      const dynamicHeight = window.innerHeight - 280;
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [scrollY]);

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(getKenyanDateTime()),
                end_date: momentDate(addDaysinDate(getKenyanDateTime(), 7)),
                department: "",
                staff_name: "",
              }}
              onFinish={getAttendanceReport}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <Form.Item
                      name="month"
                      rules={[
                        {
                          required: true,
                          message: "",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select..."
                        options={monthList}
                        getPopupContainer={() => containerRef.current}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                {/* <Select
                  // placeholder="Select Employee"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.name ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.name ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.name ?? "").toLowerCase())
                  }
                  options={concat(
                    ALL
                  )}
                  fieldNames={{
                    label: "name",
                    value: "user_id",
                  }}
                  getPopupContainer={() => containerRef.current}
                /> */}
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.label === "All Employee" ||
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(a, b) => {
                    if (a?.label === "All Employee") return -1;
                    if (b?.label === "All Employee") return 1;
                    return (a?.label ?? "").localeCompare(b?.label ?? "");
                  }}
                  // placeholder="Select Employee"
                  // placeholder="Select"
                  options={[
                    {
                      value: "",
                      label: "All Employee",
                    },
                    ...STAFF_LIST,
                  ]}
                  fieldNames={{
                    label: "label",
                    value: "value",
                  }}
                  // options={concat(
                  //   {
                  //     user_id: "",
                  //     name: "All Employee",
                  //   },
                  //   STAFF_LIST
                  // )}
                  value={staffName}
                  onChange={handleChange}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <div className="d-flex align-items-center gap-2">
            <Dropdown
              overlay={sortMenu}
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={() => containerRef.current}
            >
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  border: 0,
                }}
              >
                <SortAscendingOutlined />
              </Button>
            </Dropdown>
            <StyledButtonoutlined
              onClick={prepareCSV}
              disabled={lateCheckinList?.length === 0 || null || undefined}
            >
              Export CSV file
            </StyledButtonoutlined>
            <CSVLink
              header={CSVHeaders}
              data={CSVcheckinList}
              filename={"latecheckin-report.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </Col>
      </Row>
      <Spin spinning={displayTableLoader}>
        <StyledTable
          style={{ height: "600px !important" }}
          dataSource={lateCheckinList}
          columns={finalColumns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          scroll={{ y: scrollY }}
          id="Table"
          pagination={lateCheckinList.length > 100 ? paginationOptions : false}
          onChange={handleTableChange}
        />
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
});

export default connect(mapStateToProps, null)(LateCheckIn);
